import { createSelector } from "reselect";
import { descSortCompare } from "~/utils/utils.jsx";

export const getAllProjectTemplates = (state) => state.project_templates;

const getActiveProjectTemplates = createSelector(getAllProjectTemplates, (projectTemplates) => {
  if (!projectTemplates.size) return [];
  return projectTemplates
    .filter((t) => !t.get("is_trashed") && !t.get("is_draft"))
    .toList()
    .toJS();
});

export const getProjectTemplatesForList = createSelector(getAllProjectTemplates, (projectTemplates) => {
  if (!projectTemplates.size) return [];
  return projectTemplates
    .filter((t) => !t.get("is_trashed"))
    .sort((p1, p2) => descSortCompare(p1.get(`created_on`), p2.get(`created_on`)))
    .sort((p1, p2) => p1.get(`name`).localeCompare(p2.get(`name`)))
    .toArray();
});

export const getActiveSortedProjectTemplates = createSelector(getActiveProjectTemplates, (projectTemplates) => {
  return projectTemplates.sort((p1, p2) => p1.name.localeCompare(p2.name));
});

export const getTemplatesForApplying = createSelector(getProjectTemplatesForList, (templates) =>
  templates.filter((t) => !t.get("is_draft"))
);

export const getProjectTemplateById = (state, id) => state.project_templates.get(`${id}`);

export const getProjectTemplateMemberIds = createSelector(getProjectTemplateById, (template) => {
  if (!template) return [];
  return template.get("members").toJS();
});
